// /src/pages/guestAccess/guestAccessApi.js

import axios from 'axios';

export const GUEST_ACCESS_WS_CHANNEL = 'guestAccessRequests';

export async function fetchMyGuestAccessStatus({ forViewAsSubject = false } = {}) {
  const { data } = await axios.get('/api/user/guest-access/status', {
    withCredentials: true,
    // Default: always the logged-in user. View-as preview must target the subject.
    skipViewAs: !forViewAsSubject,
  });
  return data;
}

export async function requestGuestAccess({ forViewAsSubject = false } = {}) {
  const { data } = await axios.post(
    '/api/user/guest-access/request',
    {},
    {
      withCredentials: true,
      skipViewAs: !forViewAsSubject,
    },
  );
  return data;
}

export async function fetchPendingGuestAccessRequests() {
  const { data } = await axios.get('/api/admin/guest-access/pending', {
    withCredentials: true,
  });
  return data;
}

export async function fetchPendingGuestAccessCount() {
  const { data } = await axios.get('/api/admin/guest-access/pending-count', {
    withCredentials: true,
  });
  return data;
}

export async function acceptGuestAccessRequest(id) {
  const { data } = await axios.post(
    `/api/admin/guest-access/${id}/accept`,
    {},
    { withCredentials: true },
  );
  return data;
}

export async function rejectGuestAccessRequest(id) {
  const { data } = await axios.post(
    `/api/admin/guest-access/${id}/reject`,
    {},
    { withCredentials: true },
  );
  return data;
}

export async function guestAccessWsLastSeen(lastSeenWsLogId) {
  const { data } = await axios.post(
    '/api/user/guest-access/ws-last-seen',
    typeof lastSeenWsLogId === 'undefined' ? {} : { lastSeenWsLogId },
    { withCredentials: true },
  );
  return data;
}

export async function getGuestAccessWsDiff() {
  const { data } = await axios.post(
    '/api/user/guest-access/ws-diff',
    {},
    { withCredentials: true },
  );
  return data;
}

export async function wsResumeGuestAccessRequests(sinceSeq = 0) {
  const { data } = await axios.post(
    '/api/ws-resume/guest-access-requests',
    { sinceSeq },
    { withCredentials: true },
  );
  return data;
}
